import axios from 'axios'
import moment from 'moment'
const mixin = {
    data() {
        return {
            th: this.$thaidate,
            axios: axios,
        }
    },

    methods: {
        getUsername() {
            let userData = JSON.parse(localStorage.getItem('data'))
            return userData.user_id
        },

        getUserOrganize() {
            if (localStorage.getItem('data')) {
                let result = JSON.parse(localStorage.getItem('data')).organize_id
                return result
            } else {
                return null
            }
        },

        getUserPermiss() {
            let result = JSON.parse(localStorage.getItem('data')).permission_id
            return result
        },

        checkNotAdminPermission(data) {
            let userPermiss = this.getUserPermiss()
            let resultOrg = this.getUserOrganize()
            let paramsOrg = data

            if (userPermiss == 'pl-000001') {
                return true
            } else {
                if (resultOrg === paramsOrg) {
                    return true
                } else {
                    return false
                }
            }
        },

        checkPermission() {
            let result = JSON.parse(localStorage.getItem('data')).permission_id

            // ดูข้อมูลและแก้ไขได้ทุกหน่วยงาน (pl-000001)
            // ดูข้อมูลได้ทุกหน่วยงานและแก้ไขข้อมูลได้เฉพาะส่วนราชการตน (pl-000002)
            // ดูข้อมูลได้ส่วนราชการตนและแก้ไขข้อมูลได้เฉพาะส่วนราชการตน (pl-000003)

            if (result != 'pl-000003') {
                return true
            } else {
                return false
            }
        },

        formatTime(str) {
            return moment(str).format('YYYY-MM-DD [เวลา] HH:mm:ss')
        },

        formatTopic(str) {
            if (str.includes('suggestion')) {
                return 'ข้อเสนอแนะ'
            } else if (str.includes('permission')) {
                return 'ระดับสิทธิ์'
            } else if (str.includes('system user')) {
                return 'ผู้ใช้งานระบบ'
            } else if (str.includes('menu')) {
                return 'เมนูการใช้งาน'
            } else if (str.includes('general system')) {
                return 'พื้นฐานระบบ'
            } else if (str.includes('province')) {
                return 'จังหวัด'
            } else if (str.includes('amphur')) {
                return 'อำเภอ'
            } else if (str.includes('tambon')) {
                return 'ตำบล'
            } else if (str.includes('evacuation')) {
                return 'พื้นที่อพยพ'
            } else if (str.includes('risk level')) {
                return 'ระดับความเสี่ยง'
            } else if (str.includes('risk area')) {
                return 'พื้นที่เสี่ยงภัย'
            } else if (str.includes('organize')) {
                return 'หน่วยงาน'
            } else if (str.includes('prevent')) {
                return 'ระบบป้องกัน/บรรเทาสาธารณภัย'
            } else if (str.includes('course')) {
                return 'หลักสูตรการฝึกอบรม'
            } else if (str.includes('officer')) {
                return 'กำลังคน'
            } else if (str.includes('device')) {
                return 'อุปกรณ์'
            } else if (str.includes('incident')) {
                return 'ชุดเผชิญเหตุ'
            } else if (str.includes('equipment')) {
                return 'เครื่องมือ อุปกรณ์/ยานพาหนะ'
            } else if (str.includes('building')) {
                return 'อาคาร/สิ่งปลูกสร้าง'
            } else if (str.includes('UN')) {
                return 'UN Number (สารเคมี)'
            } else if (str.includes('disaster')) {
                if (str.includes('people')) {
                    return 'สาธารณภัย (แจ้งเหตุจากประชาชน)'
                } else {
                    return 'สาธารณภัย'
                }
            } else if (str.includes('family')) {
                return 'ครอบครัวผู้ประสบภัย'
            } else if (str.includes('person')) {
                return 'ผู้ประสบภัย (บุคคล)'
            }
        }
    }
}

export default mixin